import { AbstractDataProviderV2 } from 'components/system/data-provider';
import { CustomerUpdateActiveForSelection } from 'common/customers/services/types/CustomerUpdateActiveForSelection';

export class CustomerActiveDataProvider extends AbstractDataProviderV2<{}, {}, {}, CustomerUpdateActiveForSelection> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/active');
    }
    patch(): Promise<null> {
        return Promise.reject('Method is not supported');
    }
    list(): Promise<null> {
        return Promise.reject('Method is not available');
    }

    get(): Promise<null> {
        return Promise.reject('Method is not available');
    }
    add(): Promise<null> {
        return Promise.reject('Method is not available');
    }
    protected notify() {} // for correct work archived/unarchived in src/customers/listing/page/actions/index.js:65
}
